import React from "react";
import PropTypes from "prop-types";

/**
 * Error state for scope load failure. Calm, user-friendly message + Retry.
 */
// `bare` drops the card chrome and the heading so this can sit as one row inside a larger
// details panel, which already supplies both.
const ScopeErrorState = ({ onRetry, bare }) => {
  const body = (
    <div className={bare ? "" : "text-center py-6"}>
      <p className="text-sm font-medium text-text mb-1">
        We couldn&apos;t load the scope.
      </p>
      {!bare && (
        <p className="text-xs text-text-2 mb-4 max-w-xs mx-auto">
          Try again, or check your connection.
        </p>
      )}
      {onRetry &&
        (bare ? (
          <button
            type="button"
            onClick={onRetry}
            className="text-sm font-medium text-primary hover:text-primary-hover transition-colors cursor-pointer"
          >
            Retry
          </button>
        ) : (
          <button
            type="button"
            onClick={onRetry}
            className="inline-flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium text-white bg-primary hover:bg-primary-hover rounded-ctrl transition-colors duration-150 cursor-pointer"
          >
            Retry
          </button>
        ))}
    </div>
  );

  if (bare) return body;

  return (
    <section className="bg-card border border-card-bd rounded-card p-5">
      <h3 className="text-sm font-semibold text-text uppercase tracking-wide mb-3">
        Budget scope
      </h3>
      {body}
    </section>
  );
};

ScopeErrorState.propTypes = {
  onRetry: PropTypes.func,
  bare: PropTypes.bool,
};

export default ScopeErrorState;
